import { WorkflowSidebarButton } from '@salecycle/ui-component-library';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSendEmail } from './hooks/useSendEmail';
import { NodeIds } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/utils/NodeTypeKeys';

export function SendEmailButton() {
  const { t } = useTranslation('campaigns');
  const { addToFlow, onMessageDragged, onMessageDragEnd } = useSendEmail();

  const onDrag = useCallback(() => {
    onMessageDragged();
  }, [onMessageDragged]);

  const onDrop = useCallback(
    (dropLocation: string) => {
      addToFlow(dropLocation ?? NodeIds.dropzone);
    },
    [addToFlow],
  );

  const onDragEnd = useCallback(() => {
    onMessageDragEnd();
  }, [onMessageDragEnd]);

  return (
    <WorkflowSidebarButton
      icon="envelope"
      aria-label={t('onsite.editor.workflow.sendEmailMessage.messageAria')}
      dragId="send-email"
      onDrop={onDrop}
      onDrag={onDrag}
      onDragEnd={onDragEnd}
      onMouseOver={onDrag}
      onMouseOut={onDragEnd}
    >
      {t('onsite.editor.workflow.sendEmailMessage.message')}
    </WorkflowSidebarButton>
  );
}
